export const GET_LIST_DUNOGIAONHANVIEN = "GET_LIST_DUNOGIAONHANVIEN";
export const GET_LIST_DUNOGIAONHANVIEN_SUCCESS =
  "GET_LIST_DUNOGIAONHANVIEN_SUCCESS";
export const GET_LIST_DUNOGIAONHANVIEN_FAILURE =
  "GET_LIST_DUNOGIAONHANVIEN_FAILURE";

export const UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN =
  "UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN";
